export default __webpack_public_path__ + "static/media/Armwraps of the Precursor.3de2d361.jpg";